module.exports = __webpack_public_path__ + "static/Imp-87f6ef9d0b30a2c8e3cea83a97d50a7c.jpg";